<template>
    <main class="min-h-screen">
        <section class="bg-gray-light py-10 sm:py-16">
            <div class="container text-left mx-auto px-4">
                <h3 class="text-green-dark text-2xl sm:text-4xl font-semibold"><strong>{{ $t("I premi") }}</strong></h3>
                <div class="rounded-2xl bg-white mt-6 shadow-sm" v-for="faq, i in faqs" :key="i">
                    <div class="header font-bold text-sm px-8 py-4" @click="activeFaq = i" :class="{'cursor-pointer': activeFaq != i}">
                        <h5 class="float-left w-4/5"><img src="@/assets/images/prize.png" class="inline-block mr-2 h-4">{{ faq.q }}</h5>                        
                        <svg v-if="i == activeFaq" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 block float-right" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4" />
                        </svg>
                        <svg v-if="i != activeFaq" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 block float-right" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                        </svg>
                        <div class="clear-both"></div>
                    </div>
                    <div class="body px-8 py-4 text-sm border-t border-gray-200" v-if="i == activeFaq">
                        <p>{{ faq.a }}</p>
                    </div>
                </div>

                <h3 class="text-green-dark text-2xl sm:text-4xl font-semibold mt-10"><strong>{{ $t("Condizioni") }}</strong></h3>
                <p v-html="$t('Il concorso <strong>si concluderà con la pubblicazione della graduatoria</strong> e la proclamazione pubblica dei tre progetti vincitori (1°,2°,3° classificato).')" class="mt-6"></p>
                <p v-html="$t('La proclamazione del vincitore avverrà <strong>entro 15 giorni dalla fine dei lavori della Giuria</strong> e sarà pubblicata in questa pagina in una sezione dedicata.')" class="mt-6"></p>
                <p v-html="$t('NOTA: La Giuria potrà, con provvedimento motivato, giudicare non meritevole dell’assegnazione del premio nessuno dei progetti presentati, senza che i concorrenti possano chiedere il rimborso delle spese sostenute per la partecipazione al concorso.')" class="mt-6"></p>

            </div>
        </section>      
    </main>
</template>
<script>
import arrowLeftIco from '@/svg/arrow-left.vue'
import arrowRightIco from '@/svg/arrow-right.vue'
import faqsIT from '@/data/it/prizes.json'
import faqsEN from '@/data/en/prizes.json'

export default {
    data() {
        return {
            activeFaq: 0
        }
    },
    components: {arrowRightIco, arrowLeftIco},
    computed: {
        faqs() {
            if(this.$i18n.locale == 'it')
                return faqsIT
            else 
                return faqsEN
        }
    }
}
</script>
</script>